export class NetworkModel {
    id: any;
    networkCode: string;
    networkName: string;
    source: string;
    groupNetworkName: string = '';
    alithiasNetworkId: number; 
    groupNetworkId:number;
    networkType:string;
}